import { render, staticRenderFns } from "./RichTextEditori18n.vue?vue&type=template&id=27d087d9&scoped=true"
import script from "./RichTextEditori18n.vue?vue&type=script&lang=js"
export * from "./RichTextEditori18n.vue?vue&type=script&lang=js"
import style0 from "./RichTextEditori18n.vue?vue&type=style&index=0&id=27d087d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d087d9",
  null
  
)

export default component.exports